/**
 * `kal-prev`/`kal-next` — vier Wochen weiter oder zurück, gerechnet auf dem
 * vom Server gelieferten Fensteranfang (`range.from`, immer ein Montag).
 * **Keine Fachlogik:** Der Server normalisiert jedes `ab` ohnehin auf den
 * Montag seiner ISO-Woche (Spec, „Das Fenster ist vier Wochen ab Montag, und
 * der Server bestimmt es") — diese Funktion verschiebt nur ein Datum um
 * volle Wochen (28 Tage bleiben unter jedem Vielfachen von sieben ein
 * Montag), sie bestimmt nirgends selbst einen Wochenanfang.
 *
 * `Date.UTC`, nicht die lokale Zeitzone: Reine Kalenderarithmetik auf einem
 * `YYYY-MM-DD`-Text braucht keinen Zeitpunkt und keine Zeitzone, nur eine
 * Verschiebung um ganze Tage (dieselbe Zurückhaltung wie
 * `lib/date.ts::formatDate`).
 */

export function shiftWindow(fromIso: string, weeks: number): string {
  const year = Number(fromIso.slice(0, 4))
  const month = Number(fromIso.slice(5, 7))
  const day = Number(fromIso.slice(8, 10))
  const shifted = new Date(Date.UTC(year, month - 1, day + weeks * 7))
  return shifted.toISOString().slice(0, 10)
}
